import type { SuitableProductProps } from '@product/SuitableProduct/SuitableProduct';
import { SuitableProduct } from '@product/SuitableProduct/SuitableProduct';

type SuitableProductsProps = {
  suitableProducts: SuitableProductProps[];
};

export const SuitableProductsTab = ({ suitableProducts }: SuitableProductsProps) => (
  <div className="text-sm pt-0 lg:pt-8 lg:mr-8">
    {suitableProducts.map(suitableProduct => (
      <SuitableProduct
        key={`suitableProduct-${suitableProduct.productIdDisplayName || ''}`}
        title={suitableProduct.title}
        slug={suitableProduct.slug}
        usp={suitableProduct.usp}
        new={suitableProduct.new}
        image={suitableProduct.image}
        priceType={suitableProduct.priceType}
        prices={suitableProduct.prices}
        deliveryTimes={suitableProduct.deliveryTimes}
        productIdDisplayName={suitableProduct.productIdDisplayName}
        legacyLinkTarget={suitableProduct.legacyLinkTarget}
      />
    ))}
  </div>
);
